import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectTurnTimeDefinitionsState = createSelector(
  getSystem,
  ({ turnTimeDefinitions }) => turnTimeDefinitions,
);

const selectTurnTimeDefinitions = createSelector(
  selectTurnTimeDefinitionsState,
  ({ definitions }) => definitions,
);

export const selectTurnTimeDefinitionsValues = createSelector(
  selectTurnTimeDefinitions,
  Object.values,
);

export const selectActiveTurnTimeDefinitions = createSelector(
  selectTurnTimeDefinitionsValues,
  definitions => definitions.filter(({ isActive }) => isActive),
);

export const selectFilteredTurnTimeDefinitions = createSelector(
  getDebouncedSearchValue,
  selectTurnTimeDefinitionsValues,
  searchItems(({ name }) => [name]),
);

export const selectTurnTimeMetrics = createSelector(
  selectTurnTimeDefinitionsState,
  ({ metrics }) => metrics ?? [],
);

export const selectPrimaryTurnTimeMetric = createSelector(
  selectTurnTimeMetrics,
  metrics => metrics[0] ?? null,
);
